import { render, staticRenderFns } from "./Practices.vue?vue&type=template&id=e726a8de&scoped=true&"
import script from "./Practices.vue?vue&type=script&lang=js&"
export * from "./Practices.vue?vue&type=script&lang=js&"
import style0 from "./Practices.vue?vue&type=style&index=0&id=e726a8de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e726a8de",
  null
  
)

export default component.exports